import { Inter, Open_Sans, Rethink_Sans, Source_Code_Pro } from 'next/font/google';

const inter = Inter({
  subsets: ['latin'],
  style: ['normal', 'italic'],
  variable: '--font-inter',
  display: 'swap',
  preload: false,
});

const openSans = Open_Sans({
  subsets: ['latin'],
  style: ['normal', 'italic'],
  // this is not a variable font, i.e. it has separate files per weight, so only load those we need
  weight: ['400', '500', '600'],
  variable: '--font-open-sans',
  display: 'swap',
  preload: false,
});

const sourceCodePro = Source_Code_Pro({
  subsets: ['latin'],
  style: ['normal', 'italic'],
  variable: '--font-source-code-pro',
  display: 'swap',
  preload: false,
});

const rethinkSans = Rethink_Sans({
  subsets: ['latin'],
  style: ['normal', 'italic'],
  variable: '--font-rethink-sans',
  display: 'swap',
  preload: false,
});

const allFonts = {
  inter,
  openSans,
  rethinkSans,
  sourceCodePro,
} as const;

export { allFonts, inter, openSans, rethinkSans, sourceCodePro };
